module.exports = __webpack_public_path__ + "resources/icon-gift.efce0713ffedfc80.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/img/icon-gift.png
// module id = 798
// module chunks = 0 1